<template>

    <div class="my-log-wrapper">
        <template v-if="roleValue">
            <!-- 顶部轮播图 -->
            <div class="top-block">
                <hua-swipe class="my-swipe" :autoplay="3000" indicator-color="white" indicator-type="point">
                    <hua-swipe-item v-for="item in imgList" :key="item.id">
                        <hua-image fit="fill" width="100%" height="100%" radius="10" :src="item.value"></hua-image>
                    </hua-swipe-item>
                </hua-swipe>    
            </div>
            <div class="ad-box">
                <img class="ad-img" src="@/image/home_pic_ad.png" alt="">
                <!-- 为了绑定点击事件，放俩透明的盒子占位 -->
                <!-- 入校最新动态 -->
                <div class="btn btn-box1" @click="goAd(1)"></div>
                <!-- 车辆管理办法 -->
                <div class="btn btn-box2" @click="goAd(2)"></div>
            </div>
            <!-- 自主申请 -->
            <img v-if="!personCode" class="apply-img"
                src="@/image/home_pic_zzsq.png"
                alt=""
                @click="toInSchool" >
            <!-- 邀约申请 -->
            <img v-if="roleValue === 2" class="apply-img"
                src="@/image/home_pic_yysq.png"
                alt=""
                @click="toAppointment" >
            <!-- 审批管理 -->
            <div v-if="roleValue === 2" class="approve-box" @click="toPendApproval">
                <div class="num-box num1">{{approveStat['审批记录']}}</div>
                <div class="num-box num2">{{approveStat['待审批']}}</div>
                <div class="num-box num3">{{approveStat['今日新增']}}</div>
                <img src="@/image/home_pic_spgl.png" alt="">
                <div class="approve-record" @click.stop="recordClick"></div>
            </div>
            <hua-button
                style="width: 180px;margin: 20px auto;"
                round
                block
                type="primary"
                @click="getRole(3)"
            >解除绑定手机号
            </hua-button
            >
        </template>
        <template v-else>
            <SelectRole @roleSelect="getRole" />
        </template>
    </div>
</template>

<script>
import api from '@/constants/api'
import utils from "@/constants/utils";
import eventBus from '@/constants/eventBus.js'
import common from "@/view/common.js"
import { Toast } from 'vant';
import image1 from '@/image/swip-img.png'
import image2 from '@/image/test2.jpeg'
import image3 from '@/image/test3.jpeg'
import logoImg from '@/image/logo.png'
import {aes_decrypt, getKey} from '@/tools/myEncrypt'
import SelectRole from './selectRole.vue'
export default {
    components: {
        SelectRole
    },
    data() {
        return {
            // image1,
            // image2,
            // image3,
            openId: '',
            roleValue: '', // ===1为访客，2为教职工
            imgList:[
                {
                    id:1,
                    value: image1
                },
                {
                    id:2,
                    value: image2
                },
                {
                    id:3,
                    value: image3
                }
            ],
            utils,
            logoImg,
            userName: '',
            password: '',
            placeholder: '请输入',
            timer: null,
            showInvite: false,
            personId: '',
            personName: '',
            deptName:'',
            wrapperHeight:0,
            jobNumber:'',
            accountCode:'',
            accountState:'',
            pageName:'',
            approveStat: {
                '审批记录': 0,
                '待审批': 0,
                '今日新增': 0,
            },
            personCode: '',
        }
    },
    watch: {
        $route: {
            handler(newVal) {
                console.log('路由变化', newVal);
                if(newVal.query.personCode) {
                    this.init()
                }
            }
        }
    },
    methods: {
        goAd(flag) {
            // flag === 1,动态，2车辆
            console.log('flag', flag);
            if(flag === 1) {
                window.location.href = 'https://mp.weixin.qq.com/s/IekdWBev2jOMVDw311wkyw'
            } else {
                window.location.href = 'https://mp.weixin.qq.com/s/bjshr0xMXK2cewvE-3Kldg'
            }
        },
        visitConfig() {
            api.getVisitConfig(130).then((res) => {
                if (res.data[0].value == 0) {
                    this.showInvite = false
                }else if(res.data[0].value == 1) {
                    this.showInvite = true
                }
            })
        },
        toInSchool() {
            this.$router.push('/inSchoolKnow')
        },
        // 三方单点登录进行页面跳转
        async pageJump(type) {
            // 显示提示
            Toast.loading({
                duration: 0, // 持续展示 toast
                message: '登录中...',
                forbidClick: true,
            });
            let params = {
                code: this.accountCode  ? this.accountCode :'',
                state: this.accountState ? this.accountState : '',
                type: type,
                visitorMode: type === 2 ? 2 : 1, // visitorMode:1学生2教职工，  type:2教职工 4学生
            }
            try {
                const host = window.location.origin;
                // 问题1：浏览器调用接口不能重定向，获取不到302响应头中的location
                // 问题2：window.open（）打开接口地址的话，会新开一个页面跳到重定向的那个地址
                // 问题3：window.location.href打开接口地址的话，会在当前页面跳转到重定向的那个地址，跳完并不会执行以下代码。
                const url = `/evo-apigw/evo-channel/1.0.0/custom/officialAccounts/visitorSystem/login?visitorMode=${params.visitorMode}&code=${params.code}&type=${type}&state=${params.state}`
                console.log('重定向地址===', url);
                if(!canJump) {
                    return
                }
                window.location.href = url
                // 接口调用成功后，后端重定向，清除提示
                Toast.clear()
            } catch (error) {
                console.log(error, error.config,"error=================")
                this.$toast({ message: '登录失败', duration: 1000 });
            }
        },
        // 根据personCode获取人员信息
        async getPersonInfo(personCode, page) {
            try {
                // 先获取密钥
                const keyInfo = await getKey()
                if (!keyInfo) {
                    this.$toast('获取密钥失败，请重试')
                    return
                }
                // 再获取业务数据（传入时间戳）
                let res1 = await api.getIntervieweeNameByCode(personCode, undefined, keyInfo.visitorstampKey);
                if(res1.data) {
                    // 最后解密
                    const desData = await aes_decrypt(res1.data, keyInfo)
                    if (!desData) {
                        this.$toast('解密失败，请重试')
                        return
                    }
                    res1.data = desData
                }
                if (res1.success) {
                    const visitorMode = res1.data.ermPersonType ? Number(res1.data.ermPersonType) : ''
                    localStorage.setItem('visitorMode', visitorMode)
                    const res = {
                        data: res1.data || {}
                    }
                    console.log('resresres2', res);
                    this.personId = res.data.id
                    this.personName = res.data.name
                    this.deptName = res.data.deptName
                    this.jobNumber = res.data.code
                    this.phone = res.data.phone
                    if(this.personId) {
                        // console.log(`/${page}/${JSON.stringify(this.personId)}`,"this.personId====================")
                        page && this.$router.push(`/${page}/${this.personId}`)
                        sessionStorage.setItem('u_jobNumber', this.jobNumber)
                        localStorage.setItem('v_personid', JSON.stringify(this.personId))
                        sessionStorage.setItem('u_name', this.personName)
                        localStorage.setItem('u_deptName', this.deptName)
                        localStorage.setItem('u_phone', JSON.stringify(this.phone))
                    } else {
                        this.$toast('人员Id为空')
                        sessionStorage.setItem('u_jobNumber', '')
                        localStorage.setItem('v_personid', '')
                        sessionStorage.setItem('u_name', '')
                        localStorage.setItem('u_deptName', '')
                        localStorage.setItem('u_phone', '')
                    }
                }
            } catch (error) {
                this.$toast(error.errMsg)
            }
        },
        // 跳转到待审核页面
        toPendApproval () {
            localStorage.setItem('myVisitorListActive', 0);
            this.pageName = 'approvalManage';
            localStorage.setItem('pageName','approvalManage');
            let personCode = sessionStorage.getItem('u_jobNumber');
            if (personCode) {  // 先取缓存中的personCode,若缓存中存在personCode,就直接根据personCode获取人员信息进行页面跳转
                this.getPersonInfo(personCode, 'approvalManage');
                // console.log("===============1111111111111===============")
            } else {       // 缓存中不存在personCode,就走三方登录的流程
                this.pageJump(0);
                // console.log("===============222222222222222===============")
            }
            // this.$router.push(`/myVisitorList/${this.personId}`)
        },
        // 跳转到访客列表
        recordClick() {
            localStorage.setItem('myVisitorListActive', '')
            this.$router.push(`/myVisitorList/${this.personId}`)
        },
        // 跳转到邀约页面
        toAppointment () {
            localStorage.setItem('myVisitorListActive', 2);
            this.pageName = 'teacherInvita';
            localStorage.setItem('pageName','teacherInvita');
            let personCode = sessionStorage.getItem('u_jobNumber');
            if (personCode) {  // 缓存中存在personCode,就直接根据personCode获取人员信息进行页面跳转
                this.getPersonInfo(personCode, 'teacherInvita');
            } else {       // 缓存中不存在personCode,就走三方登录的流程
                this.pageJump(2);
            }
            // this.$router.push(`/myVisitorList/${this.personId}`)
        },
        toInvite() {
            // console.log(this.phone,"this.phone==============")
            // 如果url地址中存在电话号，就直接跳转到“我的预约”界面
            if (this.phone) {
                let params = {
                    phoneNum: this.phone
                }
                api.getInviteInfo(params)
                    .then((res) => {
                        eventBus.$emit('edit', res.data)
                        this.$router.push({name: 'visitorBooking', params: res.data})
                    })
                    .catch((err) => {
                        this.$toast(err.errMsg)
                    })
            } else {  // 否则，跳转到填写手机号的界面，通过手动输入手机号获取我的预约信息
                this.$router.push('/searchInvite')
            }
        },
        // 根据手机号查询被访人
        async getInterviewee() {
            try {
                // 先获取密钥
                const keyInfo = await getKey()
                if (!keyInfo) {
                    this.$toast('获取密钥失败，请重试')
                    return
                }
                // 再获取业务数据（传入时间戳）
                let res = await api.getIntervieweeNameByPhone(this.phone, keyInfo.visitorstampKey);
                // 最后解密
                const decryptData = await aes_decrypt(res.data, keyInfo)
                if (!decryptData) {
                    this.$toast('解密失败，请重试')
                    return
                }
                res.data = decryptData
                // console.log(res,"res================")
                if (res.success) {
                    this.personId = res.data.id
                    this.personName = res.data.name
                    this.deptName = res.data.deptName
                    this.jobNumber = res.data.code
                }
            } catch (error) {
                console.log(error)
            }
            sessionStorage.setItem('u_jobNumber', this.jobNumber)
            localStorage.setItem('v_personid', this.personId)
            sessionStorage.setItem('u_name', this.personName)
            localStorage.setItem('u_deptName', this.deptName)
        },
        // 获取今日审批数据
        async getApproveNum() {
            try {
                const res = await api.getApprovePersonNum(this.personCode)
                if(res.success) {
                    this.approveStat = {
                        '审批记录': res.data.reviewCount || 0,
                        '待审批': res.data.unReviewCount || 0,
                        '今日新增': res.data.todayVisitorCount || 0,
                    }
                } else {
                    this.approveStat = {
                        '审批记录': 0,
                        '待审批': 0,
                        '今日新增': 0,
                    }
                    this.$toast('获取审批统计数据失败！')
                }
            } catch(err) {
                this.approveStat = {
                    '审批记录': 0,
                    '待审批': 0,
                    '今日新增': 0,
                }
                console.log(err);
                this.$toast(err.errMsg || '获取审批统计数据失败！')
            }
        },
        // 获取访客openId和手机号
        async getOpenIdPhoneByCode() {
            try {
                const res = await api.getOpenIdPhone({
                    code: this.accountCode,
                    state: this.accountState
                })
                console.log('根据code获取openId和手机号的返回', res)
                if(res.success && res.data) {
                    localStorage.setItem('u_phone', res.data.phone || '')
                    localStorage.setItem('u_openId', res.data.openId || '')
                    this.openId = res.data.openId || ''
                }
            } catch(err) {
                console.log('err222', err);
                this.$toast((err.data && err.data.errMsg) || '获取访客手机号失败')
            }
        },
        async freeBind() {
            try {
                const res = await api.freeBindApi({
                    openId: this.openId,
                    state: this.accountState,
                })
                console.log('解绑的返回', res)
                if(res.success) {
                    if(res.data.value) {
                        this.$toast(res.errMsg || '解绑成功！')
                    } else {
                        this.$toast(res.errMsg || '解绑失败！')
                    }
                } else {
                    this.$toast(res.errMsg || '解绑失败！')
                }
            } catch(err) {
                this.$toast((err.data && err.data.errMsg) || '解除绑定失败！')
            }
        },
        getRole(flag) {
            if(flag === 1) {
                // 访客
                this.roleValue = flag;
                (this.accountCode && this.accountState && !this.openId) ? this.getOpenIdPhoneByCode() : ''
            } else if(flag === 2) {
                // 教职工
                this.pageJump(2);
                // window.location.href = '/#/log?code=1111&type=222&state=333&openId=555&personCode=147852'
                // this.roleValue = flag
            } else if(flag === 3) {
                // 解除绑定
                this.freeBind()
            } else if(flag === 4) {
                // 学生
                this.pageJump(4);
            }
        },
        init() {
            let curHref = window.location.href;
            let hrefParam = common.getUrlParams(curHref);
            this.accountCode = hrefParam.code || ((localStorage.getItem('accountCode') ? JSON.parse(localStorage.getItem('accountCode')) : ''))
            this.accountState = hrefParam.state || ((localStorage.getItem('accountState') ? JSON.parse(localStorage.getItem('accountState')) : ''))
            this.phone = hrefParam.phone
            this.openId = hrefParam.openId || localStorage.getItem('u_openId') || ''
            this.openId && localStorage.setItem('u_openId', this.openId)
            // this.visitorMode = hrefParam.visitorMode ? Number(hrefParam.visitorMode) : ''
            // localStorage.setItem('visitorMode', this.visitorMode)
            console.log('this.openId=====', this.openId);
            if (curHref.indexOf('personCode') > -1) {   //重定向跳转过来的地址
                this.personCode = hrefParam.personCode;
                let pageName = localStorage.getItem('pageName')
                if (JSON.parse(this.personCode)) {  // 链接中存在personCode, 就跳转到相应的审批或者邀约界面
                    this.roleValue = 2; // 有personCode说明是教职工，就不用显示选择角色了
                    this.openId ? '' : this.$toast('连接url上openId为空')
                    this.getApproveNum() // 获取审批统计
                    this.getPersonInfo(this.personCode, pageName);
                } else {
                    sessionStorage.setItem('u_jobNumber', '')
                    localStorage.setItem('v_personid', '')
                    sessionStorage.setItem('u_name', '')
                    localStorage.setItem('u_deptName', '')
                    localStorage.setItem('u_phone', '')
                    this.$router.push(`/${pageName}/${this.personId}`)
                }
            }
            if (this.accountCode) {
                localStorage.setItem('accountCode', JSON.stringify(this.accountCode))
            } else {
                localStorage.setItem('accountCode', '')
            }
            if(this.accountState) {
                localStorage.setItem('accountState', JSON.stringify(this.accountState))
            } else {
                localStorage.setItem('accountState', '')
            }
        }
    },
    async mounted() {
        // 需要干掉
        // const res1 = await aes_decrypt('c17cddc1854d3953ee45aadac378106e0309eb5a012e31d0b05feb7d1dcf7c3a7916ed55cf107a97301abc33895d0e4aa930fae66d45a2331fd86b96b16dda88ee809496a36ce476cadb6b57e96539a3a5ba01e604fba46423250a8a858d530f734e028782b6e167f4f6d60295a85e2108c2fa7f48727905fa36f4e6924b2789aaa8c8d9b9ba95fb761977879ee93d975c13ecda4040ca976115c92af30591fe29ee1596333d94cde09958f56de4d7fff4c81ae630a8987f3cac74941324426f568798c4f97ed6cd77fd657b94e15c0fa6b761984985fa051ce146eaaf86510bb886dd43b10a1e4adff7ec7014f6595b4e9f9bde1acfb8eb7a9c07a4a78b068625b3ec10f64264febb5231f0d7bc4e6f781cc694cc3b3040723d7569fa6c5e006d739708876492ebf8b88845cacf9c35cd738a61471081a62f9f5b63469932a490f3c0b55c7326b1e5c6bc7ef316d0164a6b9930cf7848a6b0c44949f35c4877dd5b8a3c89a17e83cfb9f7d153c128e0fb633b7212d7a83b78a57373bd12dddd066aa49f4328b0f302dccaf4e8a3ea9878f37cfb590690ec889b4ba62d511faf')
        console.log('111222mounted');
        // this.wrapperHeight = document.body.clientHeight - document.getElementById("nav-bar").offsetHeight - (document.body.clientHeight * 0.1);
        this.wrapperHeight = document.body.clientHeight;
        // this.visitConfig();
        // http://10.81.12.143:8087/#/log?code=1234&state=2345
        this.init()
    }
}
</script>
<style lang="less">
.my-log-wrapper {
    height:100vh;
    padding: 10px;
    overflow: auto;
    background-color: #ffffff;
    box-sizing: border-box;
    .hua-image {
        border-radius: 0 !important;
    }
    .hua-swipe__indicators {
        bottom: 15px;
    }
    .top-block {
        height: 180px;
        .hua-swipe {
            height: 100%;
        }
    }
    .ad-box {
        position: relative;
        margin-top: 10px;
        width: 100%;
        height: 200px;
        .ad-img {
            width: 100%;
            height: 100%;
        }
        .btn {
            position: absolute;
            width: 145px;
            height: 60px;
        }
        .btn-box1 {
            top: 48px;
            right: 13px;
        }
        .btn-box2 {
            top: 120px;
            right: 13px;
        }
    }
    .apply-img {
        margin-top: 10px;
        width: 100%;
        height: 165px;
    }
    .approve-box {
        position: relative;
        margin-top: 10px;
        height: 185px;
        .num-box {
            position: absolute;
            top: 60px;
            width: 25%;
            height: 30px;
            line-height: 30px;
            font-weight: 700;
            font-size: 20px;
            text-align: center;
        }
        .num1 {
            left: 20px;
        }
        .num2 {
            left: 50%;
            transform: translateX(-50%);
        }
        .num3 {
            right: 20px;
        }
        img {
            width: 100%;
            height: 100%;
        }
        .approve-record {
            position: absolute;
            top: 50px;
            left: 20px;
            width: 90px;
            height: 118px;
        }
    }
    .hua-button--block {
        display: block;
        width: 80%;
        height: 0.5rem;
        // margin: 40% 10% 40% 10%;
    }
}
</style>
